<template>
  <v-dialog v-model="dialog" persistent>
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <slot />
      </div>
    </template>
    <v-card>
      <v-toolbar color="white" fixed>
        <v-toolbar-title>{{ $i18n.t("Select Rate") }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn-toggle rounded style="background: transparent">
          <v-btn
            small
            :color="custom === false ? 'blue' : 'grey'"
            @click="custom = false"
          >
            <strong>
              <div
                style="width: 20px; height: 20px"
                v-if="custom !== false"
              ></div>
              <v-icon v-if="custom === false" color="white">mdi-check</v-icon
              >Standard Tariff
            </strong>
          </v-btn>

          <v-btn
            v-if="!forSupplier"
            small
            :color="custom === true ? 'blue' : 'grey'"
            @click="custom = true"
          >
            <strong>
              <v-icon v-if="custom === true" color="white">mdi-check</v-icon
              >Custom Tariff
            </strong>
          </v-btn>
        </v-btn-toggle>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text v-if="custom === false">
        <v-row>
          <v-col cols="12" md="2">
            <z-vehicle-type-select
              :label="$i18n.t('Vehicle Type')"
              class="purple-input"
              v-model="vehicleType"
              clearable
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              :label="$i18n.t('Name')"
              class="purple-input"
              v-model="name"
            />
          </v-col>
          <v-col cols="12" md="2">
            <z-currency-select
              class="purple-input"
              v-model="currency"
              clearable
            />
          </v-col>
          <v-col cols="12" md="2">
            <z-city-select
              :label="$i18n.t('Via City')"
              class="purple-input"
              v-model="via"
              :country="srcCountry"
            />
          </v-col>
          <v-col cols="12" md="2">
            <z-country-select
              :label="$i18n.t('Market')"
              class="purple-input"
              v-model="market"
              clearable
            />
          </v-col>

          <v-col cols="12" md="2" class="text-right pull-right">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="mr-0"
                  color="black"
                  text
                  fab
                  x-small
                  @click="clear(1)"
                  style="margin-right: 2px !important"
                  v-on="on"
                >
                  <v-icon>mdi-cached</v-icon>
                </v-btn>
              </template>
              <span>{{ $i18n.t("Clear Filter") }}</span>
            </v-tooltip>
            <v-btn
              color="success"
              class="mr-0"
              fab
              x-small
              dark
              @click="search()"
              :loading="loading"
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider v-if="custom === false"></v-divider>
      <v-card-text v-if="custom === false">
        <v-btn
          v-if="grid != undefined && !grid.records"
          class="text-center secondary--text pa-10"
          text
          color="primary"
          style="width: 100%"
          :loading="loading"
          >{{ $i18n.t("No records available") }}</v-btn
        >

        <v-simple-table dense v-else>
          <thead>
            <tr>
              <th class="primary--text"></th>
              <th class="primary--text">{{ $i18n.t("Vehicle Type") }}</th>
              <th class="primary--text">{{ $i18n.t("Tariff") }}</th>
              <th class="primary--text">{{ $i18n.t("Base Fare") }}</th>
              <th class="primary--text">{{ $i18n.t("KM Fare") }}</th>
              <th class="primary--text">{{ $i18n.t("Supplier") }}</th>
              <th class="text-right primary--text">{{ $i18n.t("Action") }}</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="rate in grid.rows" :key="rate._id">
              <td>
                <v-img :src="rate.pic" style="height: 40px; width: 45px" />
              </td>
              <td>
                {{ rate.vehicleTypeInfo ? rate.vehicleTypeInfo.name : null }}
              </td>
              <td>{{ rate.name }}</td>
              <td>
                {{ rate.tariffStructure.currency }}
                {{ rate.tariffStructure.baseFare }}
                <!-- <span
                  v-if="rate.tariffStructure.allottedWaitingTime"
                >
                  <br />
                  {{$i18n.t('Alloted Waiting Time')}}: {{rate.tariffStructure.allottedWaitingTime}} {{rate.tariffStructure.timeUnit}}
                </span>
                <span v-if="rate.tariffStructure.waitingTimeFare">
                  <br />
                  {{$i18n.t('Waiting Time Fare')}}:{{rate.tariffStructure.waitingTimeFare}}/{{$i18n.t('HR')}}
                </span>
                <span v-if="rate.tariffStructure.farePerKg">
                  <br />
                  {{$i18n.t('Weight Fare')}}:{{rate.tariffStructure.farePerKg}}/{{$i18n.t('KG')}}
                </span>
                <span v-if="rate.tariffStructure.farePerCubicFeet">
                  <br />
                  {{$i18n.t('Dimension Fare')}}:{{rate.tariffStructure.farePerCubicFeet}}/{{$i18n.t('Cubic Feet')}}
                </span>-->
              </td>
              <td>
                <span v-if="rate.tariffStructure.kmFare"
                  >{{ rate.tariffStructure.currency }}
                  {{ rate.tariffStructure.kmFare }}/{{ $i18n.t("KM") }}</span
                >
              </td>
              <td>{{ rate.supplierName }}</td>
              <td>
                <v-btn
                  class="float-right"
                  color="primary"
                  x-small
                  fab
                  text
                  dark
                  v-on="on"
                  @click="select(rate)"
                >
                  <v-icon>mdi-check</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <v-pagination
          v-if="grid != undefined && grid.records"
          v-model="grid.page"
          class="my-4"
          :length="grid.total"
          total-visible="10"
          @input="showPage"
        ></v-pagination>
      </v-card-text>

      <v-card-text v-if="custom === true">
        <v-row>
          <tariff-structure
            :value="fareTariff"
            :tariffObj="fareTariff"
            index="null"
          />
          <v-col cols="12" md="3">
            <z-currency-select
              class="purple-input"
              v-model="fareTariff.currency"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-if="custom == true">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
        <v-btn color="blue darken-1" @click="select1(fareTariff)">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/*eslint camelcase: ["error", {properties: "never"}]*/
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import Themeable from "vuetify/lib/mixins/themeable";
import TariffStructure from "@/views/tariff/TariffStructure.vue";

import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "RateSelect",
  components: { TariffStructure },
  props: {
    value: {
      default: false,
    },
    fab: {
      default: false,
    },
    text: {
      default: false,
    },
    client: {
      default: "self",
    },
    vendor: {
      default: "self",
    },
    startTime: {
      default: null,
    },
    endTime: {
      default: null,
    },
    src: {
      default: null,
    },
    dst: {
      default: null,
    },
    partLoad: {
      default: false,
    },
    forSupplier: {
      default: null,
    },
  },
})
export default class RateSelect extends (Vue, Themeable) {
  grid = { records: 0 };
  url = "/api/vehicleSearch/data/online/grid?rows=20";
  name = "";
  filterUrl = "";
  on = null;
  page = 1;
  dialog = false;
  selected = [];
  currency = null;
  supplier = null;
  market = null;
  via = null;
  vehicleType = null;
  serviceType = null;
  custom = false;
  // serviceTypes = [
  //   "LOCAL",
  //   "OUTSTATION",
  //   "SIGHTSEEING",
  //   "TRANSFER",
  //   "POINT_TO_POINT",
  //   "SELF_DRIVE",
  //   "FIXED_ROUTE",
  // ];
  timeUnits = ["HOUR", "MINUTE"];
  fareTariff = {
    vehicleType: null,
    tariffType: null,
    currency: null,
    timeUnit: null,
    baseFare: null,
    allotedKMs: null,
    allotedMins: null,
    vendor_id: null,
    kmFare: null,
    minFare: null,
    nightHaltFare: null,
    driverAllowance: null,
    parkingFare: null,
    resetNextDay: false,
    garageToGarage: false,
    returnFareApplicable: false,
    nightCharge: false,
    nightStartTime: null,
    nightEndTime: null,
    partLoad: this.partLoad,
    cancellationSlabs: [
      {
        amount: null,
        isAbs: true,
      },
    ],
  };

  get loading() {
    return common.loading;
  }

  get srcCountry() {
    if (this.src && this.src.country) {
      return this.src.country;
    }
    return "";
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.name = "";
    this.currency = null;
    this.vehicleType = null;
    this.supplier = null;
    this.market = null;
    this.page = 1;
    this.search();
  }

  select1(fareTariff) {
    fareTariff._id = "Custom";
    this.select({ tariffStructure: fareTariff });
  }

  select(rate) {
    this.$emit("select", rate);
    this.dialog = false;
  }

  async search() {
    let filterUrl = "";
    if (this.name) filterUrl += "&name=" + this.name;
    if (this.vehicleType) filterUrl += "&vehicleType=" + this.vehicleType;
    if (this.currency) filterUrl += "&currency=" + this.currency;
    if (this.supplier) filterUrl += "&supplier_id=" + this.supplier;
    if (this.client) filterUrl += "&client_id=" + this.client;
    if (this.vendor) filterUrl += "&vendor_id=" + this.vendor;
    if (this.startTime) filterUrl += "&startTime=" + this.startTime;
    if (this.endTime) filterUrl += "&endTime=" + this.endTime;
    if (this.market) filterUrl += "&market=" + this.market;
    if (this.src && this.src.country) {
      filterUrl += "&sourceCountry=" + this.src.country;
      filterUrl += "&sourceCity=" + this.src.city;
    }
    this.filterUrl = filterUrl;
    common.setLoading(true);
    await this.showPage(1);
  }

  tableHeight() {
    return window.innerHeight - 400 + "px";
  }

  @Watch("dialog")
  async onDialogChange(newVal) {
    if (newVal) {
      try {
        await this.search();
      } catch (e) {
        common.setError(e.message);
      }
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
.v-dialog > .v-card > .v-card__text {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-card .v-card__actions {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-dialog .v-card .v-card__title {
  padding-top: 10px;
}
</style>
